const STATES = {
  ABORTED: 'aborted',
  BLOCKED: 'blocked',
  DOWNLOADABLE: 'downloadable',
  DOWNLOADING: 'downloading',
  EXPIRED: 'expired',
  FINISHED: 'finished',
  INIT: 'init',
  INVALID: 'invalid',
  PASSWORD_PROTECTED: 'password_protected',
  PAUSED: 'paused',
  PROCESSING: 'processing',
  RECAPTCHA: 'recaptcha',
  SPAM: 'spam',
  STARTED: 'started',
  VERIFY: 'verify',
  VERIFY_ACCOUNT: 'verify-account',
  VERIFY_RESEND: 'verify-resend',
  VERIFY_ACCOUNT_SUCCESS: 'verify-account-success',
  VERIFY_ACCOUNT_FAILED: 'verify-account-failed',
  FORCE_ACCOUNT_VERIFICATION: 'force-account-verification',
} as const;

export type TransferStates = typeof STATES[keyof typeof STATES];
export const TRANSFER_STATES = Object.freeze(STATES);
